
import { Link } from "react-router-dom";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

interface MenteeDashboardHeaderProps {
  userName: string;
  avatarUrl: string;
  onNavigate: (route: string) => void;
}

const MenteeDashboardHeader = ({ 
  userName, 
  avatarUrl, 
  onNavigate 
}: MenteeDashboardHeaderProps) => {
  return (
    <>
      <div className="w-full bg-cover bg-center h-64 relative" style={{ backgroundImage: "url('/lovable-uploads/63560c3c-d7c3-4d91-b852-d2cd79229bf8.png')" }}>
        <div className="absolute inset-0 bg-emu-blue/20"></div>
        <div className="container mx-auto px-4 h-full flex items-end pb-8 relative z-10">
          <div>
            <div className="uppercase text-emu-blue font-medium tracking-wide mb-1">
              MENTEE'S
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
              Dashboard
            </h1>
          </div>
        </div>
      </div>
    </>
  );
};

export default MenteeDashboardHeader;
